import{getDomainByEnv as e}from"../../helpers/getDomainByEnv.es.js";const r=r=>`https://gsearch-api.${e(r)}.ru`;export{r as getBaseUrl};
